import { getData, postData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

const token = localStorage.getItem("token");
const userInfo = JSON.parse(localStorage.getItem("userInfo"));


export const getLeadOptions = async (query = "") => {
    const userObj = {
        label: `${userInfo.name ?? userInfo.email} ${userInfo.surname ?? ""}`,
        value: userInfo._id,
    };

    try {
        let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_LEAD_OPTIONS +
        `?userstringinput=${query}`;

        const response = await getData(requestUrl);

        console.log("Response from getLeadOptions:", response);

        if (response.status) {
        const apiData = response.data.map((item) => ({
            value: item.value,
            label: item.label,
        }));

        const userExists = apiData.some((item) => item.value === userObj.value);

        return userExists ? apiData : [...apiData, userObj];
        }
        return [userObj];
    } catch (error) {
        console.log(error.message);
        return [];
    }
};